import React from 'react'
import Page from '../../../../ui/Page'
import { Button, Popconfirm, Space, Table } from 'antd'
import useDormitory from './useDormitory'
import { groupBy } from '../../../../common/groupBy'
import './styles.css';
import DormModal from './forms/DormModal'
import RowSpan from '../../../../ui/RowSpan'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import DormRoomModal from './forms/DormRoomModal'
import DormFloorModal from './forms/DormFloorModal'

const DormitoryList = () => {
    const {
        dorms,
        dormColumns,
        dormRoomsColumns,
        fetchDormGenderFloor,
        handleRowColor,
        findFloorGenderByFloor,
        modals,
        dictionary,
        expandedRowKeys,
        handleExpand,
        currentDormId,
        isLoadingDorm,
    } = useDormitory();

    return (
        <Page title='Dormitories'>
            <Space direction='vertical' style={{ width: '100%' }}>
                <RowSpan
                    right={
                        <Button
                            type='primary'
                            icon={<PlusOutlined />}
                            onClick={() => modals.handleOpenDormModal()}
                        >
                            Create dorm
                        </Button>
                    }
                />
                <Table
                    bordered
                    dataSource={dorms?.sort((a, b) => a.id - b.id) || []}
                    columns={dormColumns}
                    rowKey='id'
                    scroll={{ x: 'max-content', }}
                    loading={isLoadingDorm}
                    expandable={{
                        onExpand: async (expanded, record) => {
                            await handleExpand(expanded, record);
                            await fetchDormGenderFloor(record.id);
                        },
                        expandedRowKeys: expandedRowKeys,
                        expandedRowRender: dorm => (
                            <Table
                                columns={[
                                    {
                                        title: "Floor",
                                        dataIndex: "floor",
                                        key: "floor",
                                    },
                                    {
                                        title: "Gender",
                                        dataIndex: "gender",
                                        key: "gender",
                                        render: (text, record) => findFloorGenderByFloor(record.floor)?.gender?.titleRu,
                                    },
                                    {
                                        dataIndex: 'action',
                                        key: 'action',
                                        render: (text, record) => (
                                            <Space >
                                                <Button
                                                    icon={<EditOutlined />}
                                                    onClick={() => modals.handleOpenDormFloorModal(currentDormId!, record.floor)}
                                                    hidden={dorm.genderType !== 3}
                                                >
                                                    Specify gender on floor
                                                </Button>
                                                <Popconfirm
                                                    title="Are you sure you want to delete this floor?"
                                                    onConfirm={() => modals.handleDeleteFloor(currentDormId!, record.floor)}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Button danger type="primary" icon={<DeleteOutlined />}>
                                                        Delete floor
                                                    </Button>
                                                </Popconfirm>
                                            </Space>
                                        ),
                                    }
                                ]}
                                dataSource={Object.values(groupBy(dorm.rooms, 'floor')).map((rooms, index) => ({
                                    key: index,
                                    floor: rooms[0].floor,
                                })).sort((a, b) => a.floor - b.floor) || []}
                                rowKey='floor'
                                rowClassName={(v) => handleRowColor(v.floor)}
                                pagination={false}
                                expandable={{
                                    expandedRowRender: record => (
                                        <Table
                                            columns={dormRoomsColumns}
                                            dataSource={dorm.rooms
                                                .filter(room => room.floor === record.floor)
                                                .sort((a, b) => a.flat_number - b.flat_number || a.number - b.number) || []
                                            }
                                            rowKey='id'
                                            pagination={false}
                                        />
                                    ),
                                }}
                            />
                        ),
                        rowExpandable: record => record.rooms !== null && record.rooms.length > 0,
                    }}
                />
            </Space>
            <DormModal
                form={modals.dormForm}
                onFinish={modals.handleCreateUpdateDorm}
                open={modals.dormModalOpen}
                onCancel={modals.handleCancelDormModal}
                genderList={dictionary?.genderListDorm}
            />
            <DormRoomModal
                form={modals.dormRoomForm}
                open={modals.dormRoomModalOpen}
                onCancel={modals.handleCancelDormRoomModal}
                onFinish={(values) => modals.handleCreateUpdateDormRoom(currentDormId!)}
            />
            <DormFloorModal
                form={modals.dormFloorForm}
                open={modals.dormFloorModalOpen}
                onCancel={modals.handleCancelDormFloorModal}
                onFinish={(values) => modals.handleCreateUpdateFloorGender(currentDormId!)}
                genderList={dictionary?.genderList}
            />
        </Page>
    )
}

export default DormitoryList